import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {MediaSourceKind} from '@Components/media-source-menu/media-source-menu.types';

/**
 * Audio's replace options. It reuses only the source half of the media vocabulary — there is no
 * image/video split to nest under, and no AI voice option is offered on a replace surface yet.
 */
export const buildAudioSourceOptions = (onSelect: (kind: MediaSourceKind) => void): ControlledListItemType[] => {
  return [
    {
      id: 'replace-audio-uploads',
      icon: 'icon-upload',
      text: window.i18next.t('pmwjs_uploads'),
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
      isSelected: false,
      onClick: (): void => {
        onSelect(MediaSourceKind.UPLOADS);
      },
    },
    {
      id: 'replace-audio-media',
      icon: 'icon-media',
      text: window.i18next.t('pmwjs_explore_media'),
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
      isSelected: false,
      onClick: (): void => {
        onSelect(MediaSourceKind.STOCK);
      },
    },
  ];
};
